import { gql } from '@apollo/client';

export const fetchNativeProductCollectionForChangeSubscription = gql`
  query fetchNativeProductCollectionForChangeSubscription($productKey: String, $offeringRelationshipType: String) {
    nativeCatalogForCollection(productKey: $productKey, offeringRelationshipType: $offeringRelationshipType) {
      nodes {
        offeringCollections {
          id
          toOfferingIds
        }
        productOfferingsForCollection {
          id
          offeringName
          product {
            id
            name
          }
        }
      }
    }
  }
`;
